import React from 'react';
import Icon from './Icon';

const TypeIcon = ({ size, className, ...props }) => {
  return (
    <Icon size={size} className={className} {...props}>
      <path
        d="M4 7V4h16v3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 20h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 4v16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default TypeIcon;